<!-- added by Samikchha Kumar on 25-Mar-2023 -->

<div class="container">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 mt-3">
      <div class="row" id="divTop" style="margin-bottom: 10px;margin-bottom: 10px;">
        <div class="col-md-9 col-xs-9">
          <div id="ButtonsTab" style="padding-left:5px;">
            <button id="btnSubmit" type="button" title="Submit" class="btn btn-primary" [disabled]="isDisabled"
              (click)="UpdateEngagementCode(1);" *ngIf="(IsNew ==1 && this.FTERecord.IsRecordActive==1)">
              <span style="width: 85px;">Submit</span>
            </button>
            <button id="btnReview" type="button" title="Review" class="btn btn-primary"
              [disabled]="FTERecord.IsReviewed || isDisabled" (click)="UpdateEngagementCode(2);" *ngIf="(IsNew ==0  && this.FTERecord.IsRecordActive==1)">
              <span style="width: 85px;">Review</span>
            </button>
            <button id="btnApprove" type="button" title="Approve" class="btn btn-primary" (click)="onExit();">
              <span style="width: 85px;">Exit</span>
            </button>
          </div>

          <div class="col-md-3 col-xs-3" style="padding-right: 0px;">
            <div style="text-align: right;padding-right:5px;margin-top:20px;">
              <h6 style="color: #808080; font-size: 13px; font-style: oblique; font-weight:bold;"></h6>
            </div>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="ErrorMessage.length > 0">
        <div class="col-md-12">
          <div style="font-size:small;">
            <img src="assets/img/error_icon.gif" /><span class="text-error" style="font-weight:bold;color:red;">The
              following errors were encountered on the page.</span>
          </div>
          <div id="divMainError" class="text-error"
            style="padding-top:0px; margin-bottom:10px;margin-left:25px; font-size:small; color:red">
            <span style="display:list-item" *ngFor="let item of ErrorMessage">{{item.message}}</span>
          </div>
        </div>
      </div>
      <div class="employee-details-wrapper">
        <div class="row">
          <div class="col-md-12">
            <div class="panel-heading">
              <h4 class="panel-title">
                <a style="color: gray; font-size: 14px;">
                  <b>FTE Details</b>
                </a>
              </h4>
            </div>
            <div class="panel-body">
              <div class="row">
                <div class="col-md-6 mb-2">
                  <div class="row">
                    <span class="col-sm-4"><b>Employee Name</b></span>
                    <div class="col-md-8 col-sm-8">
                      {{FTERecord.EmpName}}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <div class="row">
                    <span class="col-sm-4"><b>Employee Code</b></span>
                    <div class="col-md-8 col-sm-8">
                      {{FTERecord.EmpGPN}}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <div class="row">
                    <span class="col-sm-4"><b>Employee LPN</b></span>
                    <div class="col-md-8 col-sm-8">
                      {{FTERecord.EmpLPN}}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <div class="row">
                    <span class="col-sm-4"><b>DOJ</b></span>
                    <div class="col-md-8 col-sm-8">
                      {{FTERecord.EmpJoiningDate | date:"dd-MMM-yyyy"}}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <div class="row">
                    <span class="col-sm-4"><b>Entity</b></span>
                    <div class="col-md-8 col-sm-8">
                      {{FTERecord.Entity}}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <div class="row">
                    <span class="col-sm-4"><b>Work Location</b></span>
                    <div class="col-md-8 col-sm-8">
                      {{FTERecord.EmpLocation}}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <div class="row">
                    <span class="col-sm-4"><b>Title</b></span>
                    <div class="col-md-8 col-sm-8">
                      {{FTERecord.EmpTitle}}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <div class="row">
                    <span class="col-sm-4"><b>Service Line</b></span>
                    <div class="col-md-8 col-sm-8">
                      {{FTERecord.ServiceLine}}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <div class="row">
                    <span class="col-sm-4"><b>Reporting Partner</b></span>
                    <div class="col-md-8 col-sm-8">
                      {{FTERecord.EmpPartnerName}}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <div class="row">
                    <span class="col-sm-4"><b>Reporting Manager</b></span>
                    <div class="col-md-8 col-sm-8">
                      {{FTERecord.EmpManagerName}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="employee-details-wrapper mt-3">
        <div class="row">
          <div class="col-md-12">
            <div class="panel-heading">
              <h4 class="panel-title">
                <a style="color: gray; font-size: 14px;">
                  <b>Engagement Code</b>
                </a>
              </h4>
            </div>
            <div class="panel-body">
              <div class="row">
                <div class="col-md-12 mb-2">
                  <div class="row">
                    <span class="col-sm-4" >Engagement Code</span>
                    <div class=" col-sm-8">
                      <div class="form-group">
                        <p-autoComplete [(ngModel)]="EngCodeList.EngCode" [suggestions]="filteredEngSingle" autocomplete="off"
                        (completeMethod)="GetEngCodeSearch($event)" field="ENGID" [size]="30"
                        placeholder="Enter Engagement Code" [minLength]="3" aria-describedby="basic-addon3"
                        name="EngCode" (onSelect)="SetSelectedEngCode($event)" [disabled]="this.FTERecord.IsReviewed==1" [forceSelection]="true" [style]="{'width':'100%', 'height':'40px','font-size': '14px'}" [inputStyle]="{'width':'100%'}">
                        </p-autoComplete>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="panel-body">
              <div class="row">
                <div class="col-md-12" style="width: 50%;">
                  <table id="table1" class="dataTable table table-striped1">
                    <thead>
                      <tr style="margin-left: 10px;">
                        <th>
                          Engagement ID
                        </th>
                        <th>
                          Engagement Title
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr ng-class-odd="'odd'" id="gridrow">
                        <td>{{FTERecord.EngCode}}</td>
                        <td>{{FTERecord.EngTitle}}</td>
                      </tr>
                      <tr *ngIf="FTERecord.EngCode==null || FTERecord.EngCode.length==0">
                        <td colspan="15" style="text-align: center;color: red;">Record not added.</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="employee-details-wrapper mt-3">
        <div class="row">
          <div class="col-md-12">
            <div class="panel-heading">
              <h4 class="panel-title">
                <a style="color: gray; font-size: 14px;">
                  <b>Engagement Code History</b>
                </a>
              </h4>
            </div>
            <div class="panel-body">
              <div class="row">
                <div class="col-md-12" style="width: 100%;">
                  <table id="table1" class="dataTable table table-striped1">
                    <thead>
                      <tr style="margin-left: 10px;">
                        <th>Engagement Code</th>
                        <th>Engagement Status</th>
                        <th>Engagement Title</th>
                        <th>Engagement Partner</th>
                        <th>Engagement Manager</th>
                        <th>Updated By</th>
                        <th>Updated On</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr ng-class-odd="'odd'" id="gridrow"
                          *ngFor="let member of EngCodeHistoryList; let i  = index;">
                        <td>{{member.EngCode}}</td>
                        <td>{{member.EngStatus}}</td>
                        <td>{{member.EngTitle}}</td>
                        <td>{{member.EngEPName}}</td>
                        <td>{{member.EngEMName}}</td>
                        <td>{{member.EmpName}}</td>
                        <td>{{member.UpdatedOn| date: 'dd/MM/yyyy'}}</td>
                      </tr>
                      <tr *ngIf="EngCodeHistoryList==null || EngCodeHistoryList.length==0">
                        <td colspan="15" style="text-align: center;color: red;">Record not found.</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
  <!-- END by Samikchha Kumar on 25-Mar-2023 -->
